export default {
  brand: "USFansLink.study",

  nav_home: "Strona główna",
  nav_categories: "Kategorie",
  nav_articles: "Poradniki",
  nav_visit: "Odwiedź główną stronę",

  dropdown_label: "Przeglądaj kategorie",

  hero_eyebrow: "CENTRUM ZASOBÓW USFANS SPREADSHEET",
  hero_title: "USFans Spreadsheet: znajdź, porównaj i odkrywaj aktualne zasoby",
  hero_subtitle:
    "Szukasz jaśniejszego sposobu na poznanie zasobów USFans spreadsheet? USFansLink.study porządkuje poradniki, recenzje, informacje o wysyłce, zasoby magazynowe, kupony, porównania i informacje o bezpieczeństwie w jednym łatwym centrum.",
  hero_cta_primary: "Poznaj USFans Spreadsheet",
  hero_cta_secondary: "Przeczytaj poradnik dla początkujących",
  hero_trust: "Niezależne informacje • Praktyczne poradniki • Zasoby o bezpieczeństwie",

  search_title: "Szukaj zasobów USFans Spreadsheet",
  search_placeholder: "Szukaj USFans spreadsheet, wysyłki, magazynu, recenzji lub kuponów...",
  search_popular: "Popularne wyszukiwania",
  search_tags: ["USFans Spreadsheet", "Recenzja USFans", "Koszt wysyłki USFans", "Kupon USFans", "Magazyn USFans", "Czy USFans jest legalny?"],

  topics_title: "Popularne tematy",
  topics_subtitle: "Zacznij od tematu, który jest dla Ciebie najważniejszy.",

  topic_1_title: "USFans Spreadsheet",
  topic_1_desc: "Poznaj zasoby, kategorie i poradniki spreadsheet.",
  topic_2_title: "Recenzja USFans",
  topic_2_desc: "Zrozum platformę, jej funkcje i kluczowe kwestie.",
  topic_3_title: "Koszt wysyłki USFans",
  topic_3_desc: "Dowiedz się, co wpływa na ceny i jak porównać opcje.",
  topic_4_title: "Kupon USFans",
  topic_4_desc: "Dowiedz się, jak działają kupony i jak je weryfikować.",
  topic_5_title: "Magazyn USFans",
  topic_5_desc: "Zrozum magazynowanie, przetwarzanie i powiązane informacje.",
  topic_6_title: "Czy USFans jest legalny?",
  topic_6_desc: "Naucz się oceniać sygnały zaufania i zachować ostrożność.",

  value_title: "Wszystko, co musisz wiedzieć o zasobach USFans Spreadsheet",
  value_subtitle:
    "Zasoby USFans spreadsheet mogą zawierać przydatne informacje, ale ich znalezienie, porównanie i weryfikacja bywa trudne. Naszym celem jest uporządkowanie ważnych tematów w praktyczne poradniki, które łatwo zrozumieć i przeglądać.",
  value_1_title: "ODKRYJ",
  value_1_desc: "Znajdź istotne zasoby USFans spreadsheet.",
  value_2_title: "PORÓWNAJ",
  value_2_desc: "Porównaj informacje, opcje, koszty i funkcje.",
  value_3_title: "ZWIERYFIKUJ",
  value_3_desc: "Naucz się sprawdzać daty, linki, twierdzenia i informacje stron trzecich.",

  featured_title: "USFans Spreadsheet: Twój punkt wyjścia",
  featured_subtitle:
    "Zacznij od centrum USFans Spreadsheet, aby poznać poradniki, kategorie, porównania, FAQ i aktualne zasoby.",
  featured_cta: "Otwórz centrum USFans Spreadsheet",

  compare_title: "Czego szukasz?",
  compare_col_topic: "Temat",
  compare_col_best: "Najlepsze do",
  compare_col_info: "Główna informacja",
  compare_rows: [
    ["USFans Spreadsheet", "Odkrywanie zasobów", "Listy, kategorie i poradniki"],
    ["Recenzja USFans", "Badanie platformy", "Funkcje i kwestie do rozważenia"],
    ["Koszt wysyłki", "Badanie wysyłki", "Czynniki kosztów i opcje"],
    ["Kupon", "Badanie ofert", "Kupony i promocje"],
    ["Magazyn", "Badanie magazynu", "Magazynowanie i przetwarzanie"],
    ["Czy USFans jest legalny?", "Badanie zaufania", "Weryfikacja i bezpieczeństwo"],
  ],

  trust_title: "Sprawdź, zanim podejmiesz decyzję",
  trust_subtitle:
    "Informacje online zmieniają się szybko. Spreadsheet, kupon, szacunek wysyłki lub link strony trzeciej nie powinny być uznawane za dokładne tylko dlatego, że pojawiają się w internecie. Sprawdzaj daty, weryfikuj ważne informacje i korzystaj z oficjalnych źródeł przy wrażliwych działaniach.",
  trust_cta: "Przeczytaj poradnik bezpieczeństwa",

  final_title: "Gotowy na poznanie zasobów USFans Spreadsheet?",
  final_subtitle:
    "Zacznij od centrum USFans Spreadsheet, poznaj nasze najnowsze poradniki i wykorzystaj informacje do podejmowania lepszych decyzji.",
  final_cta: "Poznaj USFans Spreadsheet",
  final_secondary: "Odwiedź główną stronę",

  btn_buy_now: "kup teraz",
  btn_usfans: "usfans spreadsheet",

  categories_title: "Przeglądaj wszystkie kategorie",
  categories_subtitle: "Przejdź bezpośrednio do sekcji, której potrzebujesz, na głównej stronie.",

  articles_title: "Najnowsze poradniki USFans Spreadsheet",
  articles_subtitle: "Oryginalne, pomocne poradniki, które pomogą Ci zrozumieć zasoby USFans.",
  article_1_title: "Czym jest USFans Spreadsheet? Kompletny poradnik dla początkujących",
  article_1_desc:
    "Jasne i oryginalne wprowadzenie do zasobów USFans spreadsheet — czym są, jak pomagają i jak zacząć z nich bezpiecznie korzystać.",
  article_read: "Przeczytaj poradnik",
  article_more: "Więcej poradników wkrótce",
  article_related: "Powiązane poradniki",

  nav_shop_guide: "Przewodnik zakupowy",
  guide_eyebrow: "JAK KUPOWAĆ",
  guide_title: "Twój przewodnik zakupowy USFans",
  guide_intro:
    "Prosty przewodnik krok po kroku, jak poznawać kategorie USFans i dokończyć zamówienie na oficjalnej stronie.",
  guide_steps_title: "Jak kupować w czterech krokach",
  guide_steps: [
    { title: "Wybierz kategorię", desc: "Wybierz kategorię, taką jak buty, bluzy lub torby." },
    { title: "Przeglądaj ofertę", desc: "Otwórz kategorię na oficjalnej stronie i porównaj dostępne produkty." },
    { title: "Sprawdź szczegóły", desc: "Potwierdź cenę, dostępność, wysyłkę i dostawę przed podjęciem decyzji." },
    { title: "Dokończ zamówienie", desc: "Bezpiecznie dokończ płatność na oficjalnej stronie i zachowaj zapis zamówienia." },
  ],
  guide_cta_title: "Gotowy na zakupy?",
  guide_cta_desc: "Przejdź na oficjalną stronę i przeglądaj pełną gamę USFans we własnym tempie.",
  guide_back_home: "Wróć do strony głównej",

  footer_about: "USFansLink.study to niezależne źródło informacji. Nie jest powiązane z USFans ani żadną usługą stron trzecich wymienioną na tej stronie.",
  footer_disclaimer: "Informacje mogą ulec zmianie i należy je niezależnie zweryfikować.",
  footer_links: "Szybkie linki",
  footer_categories: "Kategorie",
  footer_rights: "Wszelkie prawa zastrzeżone.",

  cats: {
    shoes: "Buty",
    hoodies: "Bluzy / Swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie / Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna",
    jersey: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne rzeczy",
  },
};